export const ONBOARDING_COOKIE = 'skip_onboarding';